import { render, staticRenderFns } from "./ModelBody.vue?vue&type=template&id=dbcfd62c&scoped=true&"
import script from "./ModelBody.vue?vue&type=script&lang=js&"
export * from "./ModelBody.vue?vue&type=script&lang=js&"
import style0 from "./ModelBody.vue?vue&type=style&index=0&id=dbcfd62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcfd62c",
  null
  
)

export default component.exports